document.addEventListener('DOMContentLoaded', () => {
  const sticky = document.querySelector('[data-rfm-sticky]');
  const hero = document.querySelector('[data-rfm-hero]');
  const chooser = document.querySelector('[data-rfm-concerns]');
  if (!sticky || !('IntersectionObserver' in window)) return;

  const visible = new Set();

  const observer = new IntersectionObserver((entries) => {
    for (const { target, isIntersecting } of entries) {
      if (isIntersecting) visible.add(target);
      else visible.delete(target);
    }
    sticky.hidden = visible.size > 0;
  });

  for (const target of [hero, chooser]) {
    if (target) observer.observe(target);
  }
});
